// extracted by mini-css-extract-plugin
export default {"wrapper":"CancelOrder_wrapper__KVGJN","icon":"CancelOrder_icon__q2ejI"};